import React from 'react';
import { Navbar } from 'react-bootstrap';
import './Idled.css'


function Idle() {
   
   

   return (
       <div className='wholepage'>
           <div>
            <Navbar/>
           <h2 className='scanAgain'> Scan QR code to order again</h2>
            </div>
       </div>
  )
}

export default Idle;
